import styled from 'styled-components';

export const GeoHighlightTip = styled.span`
    color: ${({ theme }) => theme.components.geoHighlightTip.color};
    opacity: 0.6;
`;
